import React, { useContext } from 'react';
import RouteInfoContext from '../../route_info/RouteInfoContext';
import { BusDataType } from '../types';
import '../../../styles/SpotlightCard.css';

type SpotlightCardType = {
  data: BusDataType;
};

const SpotlightCard = ({ data }: SpotlightCardType) => {
  const { operatorName, busType, departureTimeStr, durationInMins, arrivalTimeStr, rating, noOfRatings, minFare } =
    data;

  const trainsData = useContext(RouteInfoContext);
  const { fromCity, toCity } = trainsData;

  const hours = Math.floor(durationInMins / 60);
  const mins = durationInMins % 60;

  return (
    <div className="busCard">
      <div className="busCardLeftSec">
        <div className="imgSec"></div>
        <div className="busDetail">
          <p className="busRouteTxt">
            {fromCity} - {toCity}
          </p>
          <p className="busTypeTxt">
            {operatorName}, {busType}
          </p>
          <span className="busTiming">{departureTimeStr} </span>
          <span className="journeySeperator">-</span>{' '}
          <span className="busDuration">
            {hours} hrs {mins} mins
          </span>{' '}
          <span className="journeySeperator">-</span> <span className="busTiming">{arrivalTimeStr}</span>{' '}
          {/* <span className="busJourneyDays">+1 day</span> */}
        </div>
      </div>

      <div className="ratingAndPrice">
        <div className="ratingWrapper">
          <div className="starIc" />
          <span className="ratingTxt">{rating}</span>
        </div>
        <p className="totalRatingTxt">{noOfRatings} ratings</p>
        <p className="finalPriceTxt">
          {/* <span className="ratingDiscRs">₹1700</span> */}
          <span className="ratingRs">₹{minFare}</span>
        </p>
      </div>
    </div>
  );
};

export default SpotlightCard;
